const _documentType = {
  ARTICLE: 'Article',
  OUTLINE: 'Outline',
  TEXT: 'Text',
  CITATION_ARTICLE: 'Citation Article',
  CITATION_OUTLINE: 'Citation Outline',
  CITATION_TEXT: 'Citation Text Document',
};

export default Object.freeze(_documentType);
